// extracted by mini-css-extract-plugin
module.exports = {"card":"EntrypointTextCard_card__CXsRj","text":"EntrypointTextCard_text__p6t8z"};